import { render, staticRenderFns } from "./LayoutInvitation.vue?vue&type=template&id=45c58980&scoped=true&"
import script from "./LayoutInvitation.vue?vue&type=script&lang=js&"
export * from "./LayoutInvitation.vue?vue&type=script&lang=js&"
import style0 from "./LayoutInvitation.vue?vue&type=style&index=0&id=45c58980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c58980",
  null
  
)

export default component.exports